import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory('/VAC#/'),
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/catalog',
      name: 'catalog',
      component: () => import('../views/CatalogView.vue')
    },
    {
      path: '/quiz/:carId?',
      name: 'quiz',
      component: () => import('../views/QuizView.vue')
    },
    {
      path: '/blog',
      name: 'blog',
      component: () => import('../views/BlogView.vue')
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('../views/TermsView.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('../views/PrivacyView.vue')
    },
    {
      path: '/articles/:id',
      name: 'article',
      component: () => import('../views/ArticleView.vue')
    },
    {
      path: '/cars/:id',
      name: 'car',
      component: () => import('../views/CarView.vue')
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: () => import('../views/CalculatorView.vue')
    },
    {
      path: '/vehicle-videos',
      name: 'vehicle-videos',
      component: () => import('../views/VehicleVideosView.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import('../views/ContactsView.vue')
    },
    {
      path: '/imgs/loan-rates',
      name: 'loan-rates',
      component: () => import('../views/LoanRates.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/NotFoundView.vue')
    },
  ]
})

let eventStartLoading = new Event("startLoading");
let eventFinishLoading = new Event("finishLoading");

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    window.dispatchEvent(eventStartLoading)
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  window.dispatchEvent(eventFinishLoading)
})

export default router
